module.exports = __webpack_public_path__ + "media/flags/al-86d9a39d.svg";